import { render, staticRenderFns } from "./Qualification.vue?vue&type=template&id=15f04903&scoped=true"
import script from "./Qualification.vue?vue&type=script&lang=ts"
export * from "./Qualification.vue?vue&type=script&lang=ts"
import style0 from "./Qualification.vue?vue&type=style&index=0&id=15f04903&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f04903",
  null
  
)

export default component.exports